import { elsterDocxUtils, emptyLine } from '../utils/elster_docx_utils';
import i18n from 'i18next';
import { PARTICIPATION_ONE, PARTICIPATION_TWO, POWER_OF_ATTORNEY_ONE, POWER_OF_ATTORNEY_TWO } from '../constants/elsterDocxConstants';
import generalTable from '../utils/generalTable';
import { bookmarkParagraphOptions, bookmarkStyle } from '../styles/elsterDocStyles';
const section78 = (data, elsterVersion) => {
  const {
    t
  } = i18n;
  const {
    createBookmark
  } = elsterDocxUtils;
  const bookMarkTitle = elsterVersion === 'version_8' ? 'tk_participation_9' : 'tk_participation_7';
  const powerOfAttorneyBookMarkTitle = elsterVersion === 'version_8' ? 'power_of_attorney_1_1_version_8' : 'power_of_attorney_1_1_version_7';
  return [createBookmark(t(bookMarkTitle), "anchor_".concat(bookMarkTitle), bookmarkStyle, bookmarkParagraphOptions), generalTable({
    participationOneHardcodedValue: false
  }, PARTICIPATION_ONE), emptyLine, generalTable(data, PARTICIPATION_TWO), emptyLine, createBookmark(t(powerOfAttorneyBookMarkTitle), "anchor_".concat(powerOfAttorneyBookMarkTitle), bookmarkStyle, bookmarkParagraphOptions), generalTable(data.elster_power_of_attorney, POWER_OF_ATTORNEY_ONE), emptyLine, generalTable(data.elster_power_of_attorney, POWER_OF_ATTORNEY_TWO), emptyLine];
};
export default section78;